import { createTodoCacheLock } from 'owa-todo-cache';

const caches = {};
export function getTodoCache(scenarioId: string) {
    if (!caches[scenarioId]) {
        caches[scenarioId] = createTodoCacheLock();
    }

    return caches[scenarioId];
}
